import {IntermediatePart} from "../../intermediatePart";
import {Vanity} from "../../parts/vanity";
import {createParentPositions, VANITY_TYPES} from "../../constants";

export default class WSTowelBar extends IntermediatePart {

  constructor(isChild) {
    super(isChild);
    this.partId = 'vanity_ws_towel_bar';
    this.partName = 'WS Towel Bar';
    this.translateId = "visualizer.bathroom.vanity.vanity_ws_towel_bar";
    this.visible = [Vanity.Types.Custom];
    this.canBeDisabled = true;
    if (isChild) {
      createParentPositions(this);
    }
  }

  disabledClick() {
    this.toggleLayerPositions();
  }

  handleClick(ignoreLocked) {
    const vanityParent = this.getParent().getParent();
    vanityParent.vanity_type = VANITY_TYPES.vanity_washstand;
    super.handleClick(ignoreLocked);
    vanityParent.updateVanityParts();
  }

  hideLayerCondition() {
    const vanityParent = this.getParent();
    return !vanityParent.vanityWashstand || !vanityParent.vanityWashstand.activeFeature || vanityParent.vanity_type !== VANITY_TYPES.vanity_washstand
  }

  getArrayOfConditions() {
    const conditions = super.getArrayOfConditions();
    const activeMatchingSink = this.getParent().getActiveSkuFromRelatedItem("vanity_washstand");
    if (activeMatchingSink) {
      conditions.push({
        propName: "MatchingFeature",
        propValue: activeMatchingSink
      });
    }
    return conditions
  }

  canDisplayDemoPoint() {
    return this.getParent().vanity_type === VANITY_TYPES.vanity_washstand
  }

}
